import React, { useEffect, useState } from "react";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from "common";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";

function AuthLoading(props) {
  const { t } = useTranslation();
  const [redirected, setRedirected] = useState(false);
  const {
    fetchUser,
    fetchCarTypes,
    fetchSettings,
    fetchBookings,
    fetchCancelReasons,
    fetchPromos,
    fetchDriverEarnings,
    fetchUsers,
    fetchNotifications,
    fetchEarningsReport,
    signOff,
    fetchWithdraws,
    fetchPaymentMethods,
    fetchLanguages,
    fetchWalletHistory,
    fetchCars,
    fetchComplain,
    fetchSMTP,
    fetchSos,
    fetchSMSConfig,
    fetchFleetAdminEarnings,
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const languagedata = useSelector((state) => state.languagedata);
  const settingsdata = useSelector((state) => state.settingsdata);

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch, fetchSettings]);

  useEffect(() => {
    let obj = {};
    let def1 = {};
    if (languagedata.langlist) {
      for (const value of Object.values(languagedata.langlist)) {
        obj[value.langLocale] = value.keyValuePairs;
        if (value.default === true) {
          def1 = value;
          break;
        }
      }
      if (def1 && def1.langLocale) {
        const result = localStorage.getItem("lang");
        if (result) {
          let langLocale = JSON.parse(result)["langLocale"];
          let dateLocale = JSON.parse(result)["dateLocale"];
          i18n.addResourceBundle(langLocale, "translations", obj[langLocale]);
          i18n.changeLanguage(langLocale);
          moment.locale(dateLocale);
        } else {
          i18n.addResourceBundle(
            def1.langLocale,
            "translations",
            obj[def1.langLocale]
          );
          i18n.changeLanguage(def1.langLocale);
          moment.locale(def1.dateLocale);
        }
      }

      dispatch(fetchUser());
    }
  }, [languagedata, dispatch, fetchUser]);

  useEffect(() => {
    if (settingsdata.settings) {
      dispatch(fetchLanguages());
      dispatch(fetchCarTypes());
      document.title = settingsdata.settings.appName;
    }
  }, [settingsdata.settings, dispatch, fetchLanguages, fetchCarTypes]);

  useEffect(() => {
    if (redirected) return;

    if (auth.profile) {
      if (auth.profile.usertype) {
        let role = auth.profile.usertype;

        // Load necessary data based on role
        if (role === "customer") {
          dispatch(fetchBookings());
          dispatch(fetchWalletHistory());
          dispatch(fetchPaymentMethods());
          dispatch(fetchCancelReasons());
          dispatch(fetchUsers());

          // Handle customer redirection
          const currentPath = window.location.pathname;
          if (
            currentPath === "/" ||
            currentPath === "/login" ||
            currentPath === "/auth-redirect"
          ) {
            setRedirected(true);
            window.location.replace("/addbookings");
            return;
          }
        } else if (role === "driver") {
          dispatch(fetchBookings());
          dispatch(fetchWithdraws());
          dispatch(fetchPaymentMethods());
          dispatch(fetchCars());
          dispatch(fetchWalletHistory());
        } else if (role === "admin" || role === "fleetadmin") {
          // alert(t("Kindly check your credentials and try again."));
          setRedirected(false);
        }

        // else if (role === "admin") {
        //   dispatch(fetchUsers());
        //   dispatch(fetchBookings());
        //   dispatch(fetchPromos());
        //   dispatch(fetchDriverEarnings());
        //   dispatch(fetchFleetAdminEarnings());
        //   dispatch(fetchNotifications());
        //   dispatch(fetchEarningsReport());
        //   dispatch(fetchCancelReasons());
        //   dispatch(fetchWithdraws());
        //   dispatch(fetchComplain());
        //   dispatch(fetchPaymentMethods());
        //   dispatch(fetchCars());
        //   dispatch(fetchSMTP());
        //   dispatch(fetchSMSConfig());
        //   dispatch(fetchSos());
        // } else if (role === "fleetadmin") {
        //   dispatch(fetchUsers());
        //   dispatch(fetchBookings());
        //   dispatch(fetchDriverEarnings());
        //   dispatch(fetchCars());
        //   dispatch(fetchCancelReasons());
        //   dispatch(fetchPaymentMethods());
        //   dispatch(fetchWalletHistory());
        // }
        else {
          // alert(t("not_valid_user_type"));
          dispatch(signOff());
        }
      } else {
        // alert(t("user_issue_contact_admin"));
        dispatch(signOff());
      }
    }
  }, [
    auth.profile,
    dispatch,
    fetchBookings,
    fetchCancelReasons,
    fetchDriverEarnings,
    fetchEarningsReport,
    fetchNotifications,
    fetchPromos,
    fetchUsers,
    fetchWithdraws,
    signOff,
    fetchPaymentMethods,
    fetchWalletHistory,
    fetchCars,
    fetchComplain,
    fetchSMTP,
    fetchSMSConfig,
    fetchSos,
    fetchFleetAdminEarnings,
    t,
    redirected,
  ]);

  if (redirected) {
    return <CircularLoading />;
  }

  return settingsdata.loading ? (
    <CircularLoading />
  ) : settingsdata.settings ? (
    auth.loading || !languagedata.langlist ? (
      <CircularLoading />
    ) : (
      props.children
    )
  ) : (
    <div>
      <span>No Database Settings found</span>
    </div>
  );
}

export default AuthLoading;
